<div class="lg:tw-px-[66px] md:tw-px-[19px] tw-py-[30px]">
    <div
        class="tw-flex tw-items-center tw-bg-[#024B3F] tw-rounded-[12px] tw-h-[100px] tw-w-full lg:tw-px-[30px] md:tw-px-[8px]"
    >
        <ng-container *ngFor="let tab of tabs; let i = index">
            <button
                (click)="setActive(tab.slug)"
                class="tw-flex-1 tw-text-center tw-transition-colors tw-py-[10px] tw-px-[5px] xl:tw-px-[10px]"
                [ngClass]="
                    activeTab === tab.slug
                        ? 'tw-bg-white tw-text-[#024B3F] tw-rounded-[14px]'
                        : 'tw-text-white'
                "
                [attr.ga-event-id]="tab.ga_id"
                [attr.ga-event-label]="tab.ga_label"
                [attr.ga-event-category]="tab.ga_category"
                ga-track="track"
            >
                <span
                    class="tw-inline-block tw-max-w-[160px] tw-pointer-events-none tw-whitespace-normal tw-break-words tw-text-center tw-font-bold lg:tw-text-[18px] md:tw-text-[16px]"
                >
                    {{ tab.title }}
                </span>
            </button>

            <!-- Vertical divider except after last tab -->
            <div
                *ngIf="i < tabs.length - 1"
                class="tw-h-[40px] tw-border-r tw-border-white/40 lg:tw-mx-[32px] md:tw-mx-[4px]"
            ></div>
        </ng-container>
    </div>
</div>

<!-- Tab Body -->
<div class="custom-tab-body">
    <bg-container *ngIf="activeTab === tabs[0].slug">
        <app-introduction></app-introduction>
    </bg-container>
    <bg-container *ngIf="activeTab === tabs[1].slug">
        <app-jumpstart-guide></app-jumpstart-guide>
    </bg-container>
    <bg-container *ngIf="activeTab === tabs[2].slug">
        <app-capacity-building></app-capacity-building>
    </bg-container>
    <bg-container *ngIf="activeTab === tabs[3].slug">
        <app-certification></app-certification>
    </bg-container>
    <bg-container *ngIf="activeTab === tabs[4].slug">
        <app-financing-solutions></app-financing-solutions>
    </bg-container>
</div>
